import React from 'react';
import PropTypes from 'prop-types';
import PersonChip from 'components/common/PersonChip';

/**
 * PersonRenderer — AG Grid cell renderer for people columns (created by,
 * updated by, handled by, sales/CSE in-charge, ...). The cell stays compact:
 * avatar + short name + full name. The hover/focus tooltip carries the whole
 * record — short name, full name, email, title, site office.
 *
 *   { field: 'sales_incharge', cellRenderer: PersonRenderer }
 *   { field: 'created_by', cellRenderer: PersonRenderer,
 *     cellRendererParams: { fullNameField: 'created_by_full_name',
 *                           emailField: 'created_by_email',
 *                           titleField: 'created_by_title',
 *                           siteField: 'created_by_site',
 *                           avatarUrlField: 'created_by_avatar_url' } }
 */
const PersonRenderer = ({
  value,
  data,
  fullNameField,
  emailField,
  titleField,
  siteField,
  avatarUrlField
}) => {
  if (!value) return <span className="tw-text-slate-300">—</span>;
  return (
    <PersonChip
      name={String(value)}
      fullName={fullNameField ? data?.[fullNameField] : undefined}
      email={emailField ? data?.[emailField] : undefined}
      jobTitle={titleField ? data?.[titleField] : undefined}
      site={siteField ? data?.[siteField] : undefined}
      avatarUrl={avatarUrlField ? data?.[avatarUrlField] : undefined}
      size="sm"
      className="tw-max-w-full"
    />
  );
};

PersonRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object,
  fullNameField: PropTypes.string,
  emailField: PropTypes.string,
  titleField: PropTypes.string,
  siteField: PropTypes.string,
  avatarUrlField: PropTypes.string
};

export default PersonRenderer;
